import React, { useEffect, useRef } from 'react';
interface TestimonialProps {
  text: string;
  authorName: string;
  authorRole: string;
  authorInitials: string;
  avatarGradient: string;
  date: string;
}
function TestimonialCard({
  text,
  authorName,
  authorRole,
  authorInitials,
  avatarGradient,
  date
}: TestimonialProps) {
  return <article className="bg-[var(--bg-2)] border border-[var(--border)] rounded-2xl p-6 transition-all duration-[0.25s] hover:border-[var(--border-blue)] hover:-translate-y-1 hover:shadow-[0_20px_40px_-10px_rgba(0,0,0,0.5)] flex-shrink-0 w-full lg:w-auto" data-id="element-232">
      <div className="flex items-center justify-between mb-4" data-id="element-233">
        <div className="flex gap-1" aria-label="5 estrellas" data-id="element-234">
          {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-[var(--neon)]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-235">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-236" />
            </svg>)}
        </div>
        <span className="text-xs text-[var(--text-subtle)]" data-id="element-237">{date}</span>
      </div>

      <h3 className="font-bold text-base mb-2 text-[var(--text)]" data-id="element-238">
        Excelente servicio
      </h3>

      <p className="text-sm leading-relaxed text-[var(--text-muted)] mb-5" data-id="element-239">
        {text}
      </p>

      <div className="flex items-center gap-3 pt-4 border-t border-[var(--border)]" data-id="element-240">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${avatarGradient}`} aria-hidden="true" data-id="element-241">
          {authorInitials}
        </div>
        <div data-id="element-242">
          <div className="font-semibold text-sm text-[var(--text)]" data-id="element-243">
            {authorName}
          </div>
          <div className="text-xs text-[var(--text-subtle)]" data-id="element-244">{authorRole}</div>
        </div>
      </div>
    </article>;
}
const column1Testimonials = [{
  text: 'Increíble trabajo con mi salón de uñas. El sistema de reservas online funciona perfecto y mis clientas están felices. La inversión se pagó sola en el primer mes.',
  authorName: 'Valentina Reyes',
  authorRole: 'Nails Studio Glamour',
  authorInitials: 'VR',
  avatarGradient: 'bg-gradient-to-br from-[#EC4899] to-[#DB2777] text-white',
  date: 'Hace 2 días'
}, {
  text: 'Las campañas en redes sociales que crearon para mi food truck superaron todas mis expectativas. Ahora tengo fila todos los días y mi Instagram está lleno de seguidores reales.',
  authorName: 'Carlos Mendoza',
  authorRole: 'Food Truck Sabor Latino',
  authorInitials: 'CM',
  avatarGradient: 'bg-gradient-to-br from-[#F59E0B] to-[#D97706] text-white',
  date: 'Hace 5 días'
}, {
  text: 'Mi barbería pasó de tener agenda vacía a estar llena por semanas. La página web que diseñaron es profesional y los clientes me encuentran fácil en Google. 100% recomendado.',
  authorName: 'Roberto Silva',
  authorRole: 'Barbería Clásica Premium',
  authorInitials: 'RS',
  avatarGradient: 'bg-gradient-to-br from-[#0057FF] to-[#3B82F6] text-white',
  date: 'Hace 1 semana'
}, {
  text: 'El sistema automatizado que implementaron en mi spa nos ahorra muchísimo tiempo. Las clientas reciben confirmaciones y recordatorios automáticos. Ya no perdemos citas.',
  authorName: 'Andrea Pérez',
  authorRole: 'Spa Relax & Wellness',
  authorInitials: 'AP',
  avatarGradient: 'bg-gradient-to-br from-[#8B5CF6] to-[#7C3AED] text-white',
  date: 'Hace 3 días'
}];
const column2Testimonials = [{
  text: 'Pasé de 0 a 500 seguidores en Instagram en menos de 2 meses. Las campañas están súper bien hechas y cada peso invertido en publicidad trae resultados. Mi salón está siempre lleno.',
  authorName: 'Sofía Martínez',
  authorRole: 'Nails Art Studio',
  authorInitials: 'SM',
  avatarGradient: 'bg-gradient-to-br from-[#F43F5E] to-[#E11D48] text-white',
  date: 'Hace 4 días'
}, {
  text: 'Ahora aparecemos primero en Google cuando buscan barbería en la zona. Los clientes llegan directo desde la web y las reservas online funcionan de maravilla. Muy profesionales.',
  authorName: 'Diego Torres',
  authorRole: 'Barbería El Estilo',
  authorInitials: 'DT',
  avatarGradient: 'bg-gradient-to-br from-[#10B981] to-[#059669] text-white',
  date: 'Hace 1 semana'
}, {
  text: 'La página web muestra nuestros tratamientos de forma profesional y atractiva. Las clientas reservan online fácilmente. La mejor inversión que hice para mi spa este año.',
  authorName: 'Laura González',
  authorRole: 'Spa Serenity',
  authorInitials: 'LG',
  avatarGradient: 'bg-gradient-to-br from-[#06B6D4] to-[#0891B2] text-white',
  date: 'Hace 6 días'
}, {
  text: 'La página web que me hicieron para mi taller mecánico es moderna y profesional. Los clientes confían más y las cotizaciones aumentaron 300%. Excelente equipo de trabajo.',
  authorName: 'Miguel Flores',
  authorRole: 'Taller Mecánico AutoPro',
  authorInitials: 'MF',
  avatarGradient: 'bg-gradient-to-br from-[#6366F1] to-[#4F46E5] text-white',
  date: 'Hace 2 días'
}];
const column3Testimonials = [{
  text: 'Mi negocio de uñas ahora tiene una presencia digital increíble. La web es hermosa y las clientas reservan directo desde Instagram. Las ventas subieron 250% en 3 meses.',
  authorName: 'Gabriela Ruiz',
  authorRole: 'Nails Boutique Luxury',
  authorInitials: 'GR',
  avatarGradient: 'bg-gradient-to-br from-[#A855F7] to-[#9333EA] text-white',
  date: 'Hace 3 días'
}, {
  text: 'Mi food truck pasó de ser desconocido a tener clientes formados todos los días. La estrategia digital que crearon funciona perfecto. Recuperé la inversión en menos de un mes.',
  authorName: 'Fernando López',
  authorRole: 'Food Truck Urban Bites',
  authorInitials: 'FL',
  avatarGradient: 'bg-gradient-to-br from-[#EF4444] to-[#DC2626] text-white',
  date: 'Hace 1 semana'
}, {
  text: 'El sistema de citas online cambió completamente mi clínica dental. Los pacientes agendan solos y reciben recordatorios automáticos. Cero citas perdidas. Súper recomendado.',
  authorName: 'Dra. Carmen Vega',
  authorRole: 'Clínica Dental Sonrisa',
  authorInitials: 'CV',
  avatarGradient: 'bg-gradient-to-br from-[#14B8A6] to-[#0D9488] text-white',
  date: 'Hace 5 días'
}];
const allTestimonials = [...column1Testimonials, ...column2Testimonials, ...column3Testimonials];
export function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px'
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-12 md:py-[100px] px-6 max-w-[1400px] mx-auto overflow-hidden" id="testimonios" aria-labelledby="trust-title" data-id="element-245">
      <div className="text-center mb-8 md:mb-16" data-id="element-246">
        <div className="inline-flex items-center gap-2 text-[11px] font-extrabold tracking-[0.12em] uppercase text-[var(--blue)] mb-5 reveal before:content-[''] before:block before:w-6 before:h-0.5 before:bg-[var(--blue)] before:rounded-sm justify-center" data-id="element-247">
          Testimonios
        </div>
        <h2 className="font-black text-[clamp(32px,5vw,56px)] leading-[1.05] tracking-[-0.03em] reveal delay-1" id="trust-title" data-id="element-248">
          Lo que dicen
          <br data-id="element-249" />
          <span className="text-neon" data-id="element-250">nuestros clientes.</span>
        </h2>
      </div>

      {/* Mobile: Horizontal carousel */}
      <div className="lg:hidden relative h-[400px] overflow-hidden" data-id="element-251">
        <div className="flex gap-3 testimonials-scroll-horizontal" data-id="element-252">
          {[...allTestimonials, ...allTestimonials].map((testimonial, index) => <div key={`mobile-${index}`} className="w-[80vw] max-w-[380px] flex-shrink-0" data-id="element-253">
                <TestimonialCard {...testimonial} data-id="element-254" />
              </div>)}
        </div>
      </div>

      {/* Desktop: Vertical columns */}
      <div className="hidden lg:block relative h-[900px] overflow-hidden" data-id="element-255">
        {/* Gradient masks for vertical scroll */}
        <div className="absolute top-0 left-0 right-0 h-40 bg-gradient-to-b from-[var(--bg)] via-[var(--bg)] to-transparent z-10 pointer-events-none" data-id="element-256"></div>
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[var(--bg)] via-[var(--bg)] to-transparent z-10 pointer-events-none" data-id="element-257"></div>

        {/* Three columns with different speeds */}
        <div className="grid grid-cols-3 gap-5 h-full" data-id="element-258">
          {/* Column 1 - Speed: 30s */}
          <div className="flex flex-col gap-5 testimonials-scroll-col-1" data-id="element-259">
            {[...column1Testimonials, ...column1Testimonials, ...column1Testimonials].map((testimonial, index) => <TestimonialCard key={`col1-${index}`} {...testimonial} data-id="element-260" />)}
          </div>

          {/* Column 2 - Speed: 40s (slower) */}
          <div className="flex flex-col gap-5 testimonials-scroll-col-2" data-id="element-261">
            {[...column2Testimonials, ...column2Testimonials, ...column2Testimonials].map((testimonial, index) => <TestimonialCard key={`col2-${index}`} {...testimonial} data-id="element-262" />)}
          </div>

          {/* Column 3 - Speed: 35s (medium) */}
          <div className="flex flex-col gap-5 testimonials-scroll-col-3" data-id="element-263">
            {[...column3Testimonials, ...column3Testimonials, ...column3Testimonials].map((testimonial, index) => <TestimonialCard key={`col3-${index}`} {...testimonial} data-id="element-264" />)}
          </div>
        </div>
      </div>
    </section>;
}